// extracted by mini-css-extract-plugin
module.exports = {"header":"_2IhClCEHXZH3-Gbx6o_6E6","headerCenter":"_313BTlamFk0WWj36Ou6e2I","spacer":"C4nDjrA8P9lEyl-Jw3oa0","headerHiddenSidebar":"_3N-vhXrakyWs5JPvQcjJrV"};